import { HeroProps } from "./hero-types";
import { BodyHeroStyled, DescriptionHeroStyled, HeroStyled, ImageHeroStyled, TitleHeroStyled } from "./style-component";
import { Image } from "antd";
import FormattedImage from "../formatted-image/formatted-image";

const Hero: React.FC<HeroProps> = ({ 
    alt, 
    title, 
    description, 
    thumbnail,
    webpSrc,
    fallbackSrc,
    imageComponent 
}) => {

    const imageStyles: React.CSSProperties = {
        width: '100%',
        height: 'auto',
        objectFit: 'contain' as const
    };

    const renderImage = () => {
        if (imageComponent) {
            return imageComponent;
        }

        if (webpSrc && fallbackSrc) {
            return (
                <FormattedImage
                    webpSrc={webpSrc}
                    fallbackSrc={fallbackSrc}
                    alt={alt ?? 'Image Hero'}
                    style={imageStyles}
                />
            );
        }

        return (
            <Image 
                alt={alt ?? 'Image Hero'}
                src={thumbnail} 
                preview={false}
                style={imageStyles}
            />
        );
    };

    return (
        <HeroStyled>
            <BodyHeroStyled>
                <TitleHeroStyled>
                    {title}
                </TitleHeroStyled>
                <DescriptionHeroStyled>
                    {description}
                </DescriptionHeroStyled>
                <ImageHeroStyled>
                    {renderImage()}
                </ImageHeroStyled>
            </BodyHeroStyled>
        </HeroStyled>
    );
};

export default Hero;